import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import Pillars from "@/components/sections/Pillars";
import HaloFlow from "@/components/sections/HaloFlow";
import Verticals from "@/components/sections/Verticals";
import Enterprise from "@/components/sections/Enterprise";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="bg-white" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Pillars />
        <HaloFlow />
        <Verticals />
        <Enterprise />
      </main>
      <Footer />
    </div>
  );
}
